import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "table-card" }
const _hoisted_3 = { class: "row-num" }
const _hoisted_4 = { class: "cell-text" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "cell-meta" }
const _hoisted_7 = { class: "cell-meta" }
const _hoisted_8 = { class: "cell-meta" }
const _hoisted_9 = { class: "cell-meta" }
const _hoisted_10 = { class: "cell-meta" }
const _hoisted_11 = { class: "cell-meta" }
const _hoisted_12 = { class: "cell-meta" }
const _hoisted_13 = { class: "cell-time" }

import { ref, onMounted } from 'vue'
import { HttpManager } from '@/api'
import { ElMessage } from 'element-plus'
import router from '@/router'
import CustomPagination from '@/components/common/CustomPagination.vue'

const loadingSvg = `
  <svg xmlns="http://www.w3.org/2000/svg">
    <image href="/20250706Logo.png" width="45" height="45" x="7" y="7" preserveAspectRatio="xMidYMid meet"/>
  </svg>
`;


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadRecord',
  setup(__props) {

const downloadRecords = ref([])
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)
const loading = ref(false)

const fetchDownloadRecords = async () => {
  loading.value = true
  try {
    const response = await HttpManager.getLoginDownloadRecordPage({
      page: currentPage.value,
      size: pageSize.value
    })
    downloadRecords.value = response.data.data
    total.value = response.data.total
  } catch (error) {
    console.error('获取下载记录失败:', error)
  } finally {
    loading.value = false
  }
}

const handlePaginationChange = (page: number, size: number) => {
  currentPage.value = page
  pageSize.value = size
  fetchDownloadRecords()
}

const formatFileSize = (size: number) => {
  if (!size) return '-'
  if (size < 1024) return size + 'B'
  if (size < 1024 * 1024) return (size / 1024).toFixed(1) + 'KB'
  return (size / (1024 * 1024)).toFixed(1) + 'MB'
}

const handleArtistClick = (artist: any) => {
  if (!artist?.singerId) {
    ElMessage.warning('制作人信息不完整')
    return
  }
  router.push({ path: `/singer-detail/${artist.singerId}`, query: { type: 'artist' } })
}

onMounted(() => { fetchDownloadRecords() })

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "page-header" }, [
      _createElementVNode("h2", { class: "page-title" }, "下载记录")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "element-loading-text": "加载中...",
        "element-loading-background": "rgba(0, 0, 0, 0.8)",
        "element-loading-svg-view-box": "-10, -10, 80, 80",
        "element-loading-svg": loadingSvg,
        data: downloadRecords.value,
        class: "data-table",
        "empty-text": "暂无下载记录"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "#",
            width: "60",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_3, _toDisplayString((currentPage.value - 1) * pageSize.value + scope.$index + 1), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "歌曲名称",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(scope.row.songName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "下载方式",
            width: "100",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: _normalizeClass(["cell-tag", scope.row.downloadType === '00' ? 'direct' : 'cloud'])
              }, _toDisplayString(scope.row.downloadType === '00' ? '直接下载' : '网盘下载'), 3)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "制作人",
            "min-width": "120"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: "cell-link",
                onClick: ($event: any) => (handleArtistClick(scope.row))
              }, _toDisplayString(scope.row.singerName), 9, _hoisted_5)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "曲风",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(scope.row.songStyleName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "套曲",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(scope.row.musicalCycleName || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "BPM",
            width: "70",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_8, _toDisplayString(scope.row.songBpm || '-'), 1)
            ]),
            _: 1
          }),
          false
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "时长",
                width: "70",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(scope.row.totalAudioDuration || '-'), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: "大小",
            width: "80",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_10, _toDisplayString(formatFileSize(scope.row.fileSize)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "格式",
            width: "70",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_11, _toDisplayString(scope.row.fileSuffix || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "调性",
            width: "80",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_12, _toDisplayString(scope.row.songTonality || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "下载时间",
            width: "170"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_13, _toDisplayString(scope.row.downloadTime), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createVNode(CustomPagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
        total: total.value,
        "page-size-options": [10, 20, 30, 50],
        onChange: handlePaginationChange
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ]))
}
}

})